import styled from "styled-components"

const Container = styled.div`
  background-color: ${(props) => props.theme.a_color_gradients.a_light};
`

const Title = styled.h2`
  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
`
export { Container, Title }
